<template>
  <div class="main">
    <template v-if="passengerList.length || abnormalList.length">
      <div v-for="(item, key) in passengerList" :key="key" class="cell-card">
        <div class="cell-flex-between" style="border-bottom: 1px solid #d2d2d2;padding-bottom: 12px;">
          <div class="cell-flex">
            <van-image round width="34px" height="34px" :src="item.Avatar" />
            <div style="margin-left: 8px;">{{item.Name}}</div>
          </div>
          <a :href="'tel://' + item.Phone"><van-icon name="phone" size="25" color="#FEB013"/></a>
        </div>
        <div class="cell-flex" style="padding: 8px 0;">
          <van-icon name="clock" size="15" color="#999999"/>
          <div style="padding-left: 4px;">{{item.DepartTime}}</div>
          <div style="width: 20px;"></div>
          <van-icon name="location" size="15" color="#999999"/>
          <div style="padding-left: 4px;">{{item.Way}}</div>
        </div>
        <div class="cell-flex-between">
          <div style="color:#999999;font-size: 14px;">{{item.UpDateTime}}</div>
          <div class="cell-flex">
            <van-button block plain round size="small" @click="onReject(item)">拒绝绑定</van-button>
            <div style="width: 20px;"></div>
            <van-button block round color="#333333" size="small" @click="onConfirm(item)">同意绑定</van-button>
          </div>
        </div>
      </div>
      <div v-for="(item, key) in abnormalList" :key="'a'+key" class="cell-card">
        <div class="cell-flex-between" style="border-bottom: 1px solid #d2d2d2;padding-bottom: 12px;">
          <div class="cell-flex">
            <van-tag type="primary">{{item.Type}}</van-tag>
            <div style="margin-left: 8px;">{{item.Name}}</div>
          </div>
          <a :href="'tel://' + item.Phone"><van-icon name="phone" size="25" color="#FEB013"/></a>
        </div>
        <div class="cell-flex" style="padding: 8px 0;">
          <van-icon name="clock" size="15" color="#999999"/>
          <div style="padding-left: 4px;">{{item.DateTime}}</div>
          <div style="width: 20px;"></div>
          <van-icon name="location" size="15" color="#999999"/>
          <div style="padding-left: 4px;">{{item.Way}}</div>
        </div>
        <div class="cell-flex-between">
          <div style="color:#999999;font-size: 14px;">{{item.UpDateTime}}</div>
          <div class="cell-flex">
            <van-button block plain round size="small" @click="ReAbnormal(item)">拒绝</van-button>
            <div style="width: 20px;"></div>
            <van-button block round color="#333333" size="small" @click="onAbnormal(item)">同意</van-button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <van-empty description="暂无数据" />
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
        WXInfo: {},
        form: {},
        passengerList: [],
        abnormalList: []
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"errcode":0,"errmsg":"ok","userid":"201755100","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.form.Name = this.WXInfo.name
    this.form.UserId = this.WXInfo.userid
    this.form.Phone = this.WXInfo.mobile
    this.getNeedBindData()
    this.getAbnormalList()
  },
  methods: {
    onReject (val) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否拒绝绑定？',
      })
        .then(async () => {
          // let query = {
          //   Model: 'workuser',
          //   UserId: val.UserId,
          //   Role: 'passenger'
          // }
          // let data = {
          //   DepartTime: '',
          //   Way: '',
          //   LngLat: [],
          //   Distance: 0,
          //   DriverId: '',
          //   Effictive: false,
          //   Status: false
          // }
          // const result = await this.postUpDataOrCreate(query, data)
          const result = await this.deleteFunction('workuser', val._id)
          if (result.success) {
            this.$toast('已解除绑定')
            // await this.getNeedBindData()
            this.passengerList.splice(this.passengerList.findIndex(item => { item._id === val._id }), 1)
            let message = '您提交的拼车申请，已被司机拒绝。请重新选择绑定司机。'
            this.postSendMessage(val.UserId, message)
          } else{
            this.$toast(result.message)
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    onConfirm (val) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否同意绑定？',
      })
        .then(async () => {
          let query = {
            Model: 'workuser',
            UserId: val.UserId,
            Role: 'passenger'
          }
          const result = await this.postUpDataOrCreate(query, {Effictive: true})
          if (result.success) {
            this.$toast('已确认绑定')
            this.passengerList.splice(this.passengerList.findIndex(item => { item._id === val._id }), 1)
            let message = '消息通知：' +
              '\n\n日期：' + this.$moment(new Date()).format('YYYY-MM-DD HH:mm') +
              '\n司机：' + val.DriverName +
              '\n汽车：' + val.DriverCarName + ' ' + val.DriverCarNum +
              '\n上车时间：' + val.DepartTime +
              '\n上车地点：' + val.Way + 
              '\n\n您提交的早班拼车申请，司机已同意。等待后台审核。'
            this.postSendMessage(val.UserId, message)
          } else{
            this.$toast(result.message)
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    // 司机获取乘客申请绑定数据
    async getNeedBindData() {
      const result = await this.$request({
        url: this.$api.getPassengerListByDriverId,
        method: 'GET',
        params: {
          DriverId: this.form.UserId,
          Effictive: false
        }
      })
      if (result.data.length > 0) {
        this.passengerList = result.data
        this.passengerList.map(item => {
          item.UpDateTime = this.$moment(item.UpDateTime).format('YYYY-MM-DD HH:mm:ss')
        })
      } else {
        // this.$router.push('/work/index')
      }
    },
    // 更新乘客数据
    postUpDataOrCreate (query, data) {
      return this.$request({
        url: this.$api.postUpDataOrCreateApi,
        method: 'POST',
        params: query,
        data
      })
    },
    ReAbnormal(val) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否拒绝乘客补单申请？',
      })
        .then(async () => {
          const result = await this.deleteFunction('abnormal', val._id)
          if (result.success) {
            this.$toast('已取消请求')
            this.abnormalList.splice(this.abnormalList.findIndex(item => { item._id === val._id }), 1)
            let message = '您提交 '+ val.DateTime +' 的拼车异常申请，被司机 '+ val.DName +' 拒绝。'
            this.postSendMessage(val.UserId, message)
          } else{
            this.$toast(result.message)
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    onAbnormal(val) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否同意乘客补单申请？',
      })
        .then(async () => {
          const result = await this.postAbnormal({_id: val._id}, {DStatus: true})
          if (result.success) {
            this.$toast('已提交后台')
            this.abnormalList.splice(this.abnormalList.findIndex(item => { item._id === val._id }), 1)
            let message = '补单通知：' +
              '\n\n日期：' + val.DateTime +
              '\n类型：' + val.Type +
              '\n司机：' + val.DName +
              '\n地点：' + val.Way + 
              '\n\n您提交的异常补单申请，司机已同意。等待后台审核。'
            this.postSendMessage(val.UserId, message)
          } else{
            this.$toast(result.message)
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    postAbnormal(query, data) {
      return this.$request({
        url: this.$api.postAbnormal,
        method: 'POST',
        params: query,
        data
      })
    },
    deleteFunction (model, id) {
      return this.$request({
        url: this.$api.deleteFunction,
        method: 'DELETE',
        params: {
          Name: model,
          Condition: {
            _id: id
          }
        }
      })
    },
    async getAbnormalList() {
      const result = await this.$request({
        url: this.$api.getAbnormalList,
        method: 'GET',
        params: {
          DriverId: this.form.UserId,
          DStatus: false
        }
      })
      if (result.data.length > 0) {
        this.abnormalList = result.data
        this.abnormalList.map(item => {
          item.UpDateTime = this.$moment(item.UpDateTime).format('YYYY-MM-DD HH:mm:ss')
        })
      }
    },
    // 发送消息
    async postSendMessage(userid, message) {
      const result = await this.$request({
        url: this.$api.postSendMessageWX,
        method: 'POST',
        data: {
          'touser': userid,
          'msgtype': 'text',
          'agentid': this.$agentid,
          'text': { 'content': message }
        }
      })
      if (!result.success) {
        this.$toast(result.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    height: 100%;
    overflow: hidden;
  }
  .cell-flex {
    display: flex;
    align-items: center;
  }
  .cell-flex-between {
    display: flex; 
    justify-content: space-between;
    align-items: center;
  }
  .cell-card {
    background-color: #FFFFFF;
    border-radius: 4px;
    margin: 12px;
    padding: 12px;
  }
</style>
